export const ROUTE_MATCHING_ENTRY_POINT = "matching.entryPoint";
export const ROUTE_MATCHING_LIST = "matching.list";
